document.querySelectorAll('.revrow').forEach(function(row){
  var revs=row.querySelectorAll('.rev'), dots=row.querySelector('.dots'), i=0;
  function show(k){
    i=(k+revs.length)%revs.length;
    revs.forEach(function(r,j){ r.classList.toggle('on', i===j); });
    dots.querySelectorAll('.dot').forEach(function(d,j){ d.classList.toggle('on', i===j); });
  }
  if(revs.length<2){ revs[0].classList.add('on'); dots.remove(); return; }
  revs.forEach(function(r,k){
    var d=document.createElement('button'); d.className='dot';
    d.setAttribute('aria-label','Review '+(k+1));
    d.onclick=function(){ show(k); };
    dots.appendChild(d);
  });
  show(0);
  var x0=null,y0=null,drag=false;
  row.addEventListener('pointerdown',function(e){ x0=e.clientX; y0=e.clientY; drag=true; });
  row.addEventListener('pointermove',function(e){
    if(!drag||x0===null) return;
    var dx=e.clientX-x0, dy=e.clientY-y0;
    if(Math.abs(dx)>44 && Math.abs(dx)>Math.abs(dy)){ show(i+(dx<0?1:-1)); drag=false; x0=null; }
  });
  ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
    row.addEventListener(ev,function(){ drag=false; x0=null; });
  });
  row.style.touchAction='pan-y';
});
(function(){
  var b=document.getElementById('panelbox'), last=null;
  function open(t){ last=t; b.hidden=false; b.querySelector('.pclose').focus(); }
  function close(){ b.hidden=true; if(last) last.focus(); }
  document.querySelectorAll('[data-panel]').forEach(function(t){ t.addEventListener('click',function(){ open(t); }); });
  b.querySelector('.pclose').addEventListener('click',close);
  b.addEventListener('click',function(e){ if(e.target===b) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!b.hidden) close(); });
})();
(function(){
  document.querySelectorAll('.jlp video').forEach(function(v){
    var p = v.play();
    if (p && p.catch) p.catch(function(){});
  });
})();

(function(){
  /* The theme swallows clicks on our offer CTA: something between window-capture
     and document-bubble calls stopPropagation, so the cart drawer opens empty and
     the cart permalink never loads. A window-capture listener runs before that
     handler, so we take the click and navigate ourselves. */
  window.addEventListener('click', function(e){
    var t = e.target, a = t && t.closest ? t.closest('a.cta') : null;
    if (!a) return;
    var h = a.getAttribute('href') || '';
    if (h.indexOf('/cart/') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = a.href;
  }, true);
})();
